<template>
  <div
    v-if="chart"
    class="the-answered-questions-chart"
    data-help-title="Beantwortete Fragen"
    data-help="Diese Grafik zeigt dir auf wieviele Fragen du an verschiedenen Tagen richtig oder falsch beantwortet hast."
  >
    <GChart
      v-if="chart.length > 1"
      type="ColumnChart"
      :data="chart"
      :options="chartOptions"
    />
    <div v-else class="message">
      Beantworte Fragen um diesen Bereich zu aktivieren
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GChart } from "vue-google-charts";

export default {
  name: "TheAnsweredQuestionsChart",
  components: { GChart },
  data() {
    return {
      chartOptions: {
        title: "Fragen beantwortet",
        titleTextStyle: {
          color: "#ffffff",
          fontSize: 16,
        },
        isStacked: true,
        legend: {
          position: "top",
          textStyle: { color: "#ffffff" },
          alignment: "end",
        },
        colors: ["rgb(50, 64, 80)", "#ffffff"],
        hAxis: {
          baseline: 0,
          baselineColor: "#ffffff",
          gridlineColor: "#ffffff",
          minorGridlines: { color: "#ffffff" },
          textStyle: { color: "#ffffff" },
        },
        vAxis: {
          baseline: 0,
          baselineColor: "#ffffff",
          gridlineColor: "#ffffff",
          minorGridlines: { color: "#ffffff" },
          textStyle: { color: "#ffffff" },
          minValue: 0,
        },
        backgroundColor: "rgb(57, 158, 139)",
        chart: {
          title: "Fragen beantwortet",
        },
        width: "95%",
        chartArea: {
          left: 5,
          width: "95%",
        },
      },
    };
  },
  computed: {
    chart() {
      if (this.me && this.me.answer_data) {
        let data = this.me.answer_data.map((d) => {
          let parts = d.date.split("-");
          let date = parts[2] + "." + parts[1];
          return [date, parseInt(d.correct, 10), parseInt(d.wrong, 10)];
        });
        return [["Datum", "Richtig", "Falsch"], ...data];
      }
      return [];
    },
    ...mapGetters(["me"]),
  },
};
</script>

<style lang="scss" scoped>
.the-answered-questions-chart {
  background: $green;
  border-bottom: 5px solid #ffffff;
  padding: 10px;

  .message {
    color: #ffffff;
    padding: 20px;
    text-align: center;
  }
}
</style>
